/**
 * Project-list heights that keep each dialog inside the window: the viewport
 * less everything the dialog stacks around the editor (its padding, header,
 * footer and the 2rem margin `max-h` leaves), clamped to a usable minimum and
 * the full 26rem. The invite dialog also carries the email and role fields.
 */
export const MEMBER_ACCESS_PANE_HEIGHT = {
  manage: "clamp(12rem, 100dvh - 21rem, 26rem)",
  invite: "clamp(12rem, 100dvh - 34rem, 26rem)",
} as const;
